export default __webpack_public_path__ + "static/media/softretail.1292f972.png";